import { Input, ArticleHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './BubbleInput.css';
import { TTextFieldType } from '../../types/messageBubble';

type TBubbleInputProps = {
  value: string;
  type?: TTextFieldType;
  buttonName: string;
  placeholder?: string | null;
  onChange: (value: string) => void;
  onSend: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
};

export const BubbleInput: React.FC<TBubbleInputProps> = ({
  value,
  type = 'text',
  buttonName,
  placeholder,
  onChange,
  onSend,
  onFocus,
  onBlur,
}) => {
  const hasValue = Boolean(value.trim());

  return (
    <div className={styles['container']}>
      <Input
        value={value}
        maxLength={100}
        size="M"
        type={type}
        placeholder={placeholder ?? undefined}
        minWidth={260}
        onChange={(_, value) => onChange(value)}
        data-name="BubbleInput_input"
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {hasValue && (
        <button className={styles['button']} onClick={onSend} data-name="BubbleInput_button">
          <ArticleHeading4 color="text-main-default">{buttonName}</ArticleHeading4>
        </button>
      )}
    </div>
  );
};
